import React from 'react';
import { useTranslation } from 'react-i18next';

const BatchMode: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('production.batchFlash')}
      </h3>
      <div className="space-y-4">
        <div className="flex gap-3">
          <input
            type="text"
            placeholder={t('production.serialNumber')}
            className="flex-1 border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            disabled
          />
          <button
            disabled
            className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium disabled:opacity-50"
          >
            {t('production.flashNext')}
          </button>
        </div>
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <p className="text-2xl font-bold text-gray-900 dark:text-white">0</p>
            <p className="text-xs text-gray-500">{t('production.totalFlashed')}</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-red-500">0</p>
            <p className="text-xs text-gray-500">{t('production.totalFailed')}</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-green-500">--</p>
            <p className="text-xs text-gray-500">{t('production.successRate')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BatchMode;
